module.exports = __webpack_public_path__ + "img/result-oman-05.3f61cddf.svg";